import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar-menu-set" }

import { useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesSidebar',
  setup(__props) {

const route = useRoute()

function toggleSidebar() {
  const sidebar = document.querySelector('.sidebar')
  if (sidebar) {
    sidebar.classList.toggle('close')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", {
      class: "sidebar-icon",
      onClick: toggleSidebar
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "barr1" }, null, -1),
      _createElementVNode("div", { class: "barr2" }, null, -1),
      _createElementVNode("div", { class: "barr3" }, null, -1)
    ]))]),
    _createElementVNode("div", {
      class: "sidebar-icon close",
      onClick: toggleSidebar
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("div", { class: "barr1" }, null, -1),
      _createElementVNode("div", { class: "barr2" }, null, -1),
      _createElementVNode("div", { class: "barr3" }, null, -1)
    ]))]),
    _createElementVNode("ul", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/front/collectivites/ma-collectivite" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["sidebar-menu-animate", { active: _ctx.$route.name === 'ma-collectivite' || _ctx.$route.name === 'ma-collectivite-edit' }])
          }, [
            _createElementVNode("li", {
              class: _normalizeClass(["sidebar-menu", { active: _ctx.$route.name === 'ma-collectivite' || _ctx.$route.name === 'ma-collectivite-edit' }])
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-collectivite.svg",
                class: "sidebar-menu-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Ma collectivité", -1),
              _createElementVNode("div", { class: "my-badge br2 dot bg-color-notif" }, null, -1)
            ]))], 2)
          ], 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/front/collectivites/dashboard" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["sidebar-menu-animate", { active: _ctx.$route.name === 'collectivites-dashboard' }])
          }, [
            _createElementVNode("li", {
              class: _normalizeClass(["sidebar-menu", { active: _ctx.$route.name === 'collectivites-dashboard' }])
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-dashboard.svg",
                class: "sidebar-menu-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Dashboard", -1),
              _createElementVNode("div", { class: "my-badge br2 dot bg-color-warning" }, null, -1)
            ]))], 2)
          ], 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/front/collectivites/onboarding-groupe" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["sidebar-menu-animate", { active: _ctx.$route.name === 'collectivites-onboarding-groupe' }])
          }, [
            _createElementVNode("li", {
              class: _normalizeClass(["sidebar-menu", { active: _ctx.$route.name === 'collectivites-onboarding-groupe' }])
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-onboarding-groupe.svg",
                class: "sidebar-menu-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Onboarding groupé", -1),
              _createElementVNode("div", { class: "my-badge br2 dot bg-color-notif" }, null, -1)
            ]))], 2)
          ], 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/front/collectivites" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["sidebar-menu-animate", { active: _ctx.$route.name === 'collectivites' }])
          }, [
            _createElementVNode("li", {
              class: _normalizeClass(["sidebar-menu", { active: _ctx.$route.name === 'collectivites' }])
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-onboarding.svg",
                class: "sidebar-menu-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Onboarding", -1),
              _createElementVNode("div", { class: "my-badge br2 dot bg-color-notif" }, null, -1)
            ]))], 2)
          ], 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/front/collectivites/membres" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["sidebar-menu-animate", { active: _ctx.$route.name === 'collectivites-membres' }])
          }, [
            _createElementVNode("li", {
              class: _normalizeClass(["sidebar-menu", { active: _ctx.$route.name === 'collectivites-membres' }])
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-collectivite.svg",
                class: "sidebar-menu-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Gérer mes membres", -1),
              _createElementVNode("div", { class: "my-badge br2 dot bg-color-notif" }, null, -1)
            ]))], 2)
          ], 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/front/collectivites/kyc-membres" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["sidebar-menu-animate", { active: _ctx.$route.name === 'collectivites-kyc-membres' || _ctx.$route.name === 'collectivites-kyc-membre-detail' }])
          }, [
            _createElementVNode("li", {
              class: _normalizeClass(["sidebar-menu", { active: _ctx.$route.name === 'collectivites-kyc-membres' || _ctx.$route.name === 'collectivites-kyc-membre-detail' }])
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-collectivite.svg",
                class: "sidebar-menu-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "KYC des membres", -1),
              _createElementVNode("div", { class: "my-badge br2 dot bg-color-warning" }, null, -1)
            ]))], 2)
          ], 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/front/collectivites/recouvrement" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["sidebar-menu-animate", { active: _ctx.$route.name === 'collectivites-recouvrement' }])
          }, [
            _createElementVNode("li", {
              class: _normalizeClass(["sidebar-menu", { active: _ctx.$route.name === 'collectivites-recouvrement' }])
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-recouvrement.svg",
                class: "sidebar-menu-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Prélèvement", -1),
              _createElementVNode("div", { class: "my-badge br2 dot bg-color-notif" }, null, -1)
            ]))], 2)
          ], 2)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})